// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__pvalc","top":"styles_top__1VxxM"};